import React from 'react';
import styles from '../Styles/ResumeBuilder.module.css';

import t1 from '../Assets/template1.png';
import t2 from '../Assets/template2.png';
import t3 from '../Assets/template3.png';
import t4 from '../Assets/template4.png';
import t5 from '../Assets/template5.png';
import t6 from '../Assets/template6.png';

const Resume_builder = ({onEdit}) => {
    return(
    <div className={styles.container}>
        <div className={styles.row}>
		<div className={styles.column}>
			<div className={styles.cards}>
				<img src={t1} alt='t1'></img>
				<button className={styles.button1} onClick={onEdit}>Edit this template</button>
			</div>
		</div>
		<div className={styles.column}>
			<div className={styles.cards}>
            <img src={t2} alt='t2'></img>
			<button className={styles.button1}>Edit this template</button>
			</div>
		</div>
		<div className={styles.column}>
			<div className={styles.cards}>
            <img src={t3} alt='t3'></img>
			<button className={styles.button1}>Edit this template</button>
			</div>
		</div>
</div>


<div className={styles.row}>
		<div className={styles.column}>
			<div className={styles.cards}>
            <img src={t4} alt='t4'></img>
			<button className={styles.button1}>Edit this template</button>
			</div>
		</div>
		<div className={styles.column}>
			<div className={styles.cards}>
			<img src={t5} alt='t5'></img>
			<button className={styles.button1}>Edit this template</button>
			</div>
		</div>
		<div className={styles.column}>
			<div className={styles.cards}>
            <img src={t6} alt='t6'></img>
			<button className={styles.button1}>Edit this template</button>
			</div>
		</div>
</div>
</div>
    );
};

export default Resume_builder;